/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiQuickStatusComment,
    ApiQuickStatusCommentFromJSON,
    ApiQuickStatusCommentToJSON,
} from '../models';

export interface AddStatusCommentRequest {
    apiQuickStatusComment: ApiQuickStatusComment;
}

export interface DeleteStatusCommentRequest {
    id: number;
}

export interface UpdateStatusCommentRequest {
    apiQuickStatusComment: ApiQuickStatusComment;
}

/**
 * 
 */
export class QuickStatusCommentApi extends runtime.BaseAPI {

    /**
     * Creates new status comment
     */
    async addStatusCommentRaw(requestParameters: AddStatusCommentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiQuickStatusComment>> {
        if (requestParameters.apiQuickStatusComment === null || requestParameters.apiQuickStatusComment === undefined) {
            throw new runtime.RequiredError('apiQuickStatusComment','Required parameter requestParameters.apiQuickStatusComment was null or undefined when calling addStatusComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/quick-status-comments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiQuickStatusCommentToJSON(requestParameters.apiQuickStatusComment),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiQuickStatusCommentFromJSON(jsonValue));
    }

    /**
     * Creates new status comment
     */
    async addStatusComment(requestParameters: AddStatusCommentRequest, initOverrides?: RequestInit): Promise<ApiQuickStatusComment> {
        const response = await this.addStatusCommentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an existing status comment
     */
    async deleteStatusCommentRaw(requestParameters: DeleteStatusCommentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteStatusComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/quick-status-comments/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an existing status comment
     */
    async deleteStatusComment(requestParameters: DeleteStatusCommentRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteStatusCommentRaw(requestParameters, initOverrides);
    }

    /**
     * Fetches all status comments
     */
    async getStatusCommentsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ApiQuickStatusComment>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/quick-status-comments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiQuickStatusCommentFromJSON));
    }

    /**
     * Fetches all status comments
     */
    async getStatusComments(initOverrides?: RequestInit): Promise<Array<ApiQuickStatusComment>> {
        const response = await this.getStatusCommentsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Updates status comment
     */
    async updateStatusCommentRaw(requestParameters: UpdateStatusCommentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiQuickStatusComment>> {
        if (requestParameters.apiQuickStatusComment === null || requestParameters.apiQuickStatusComment === undefined) {
            throw new runtime.RequiredError('apiQuickStatusComment','Required parameter requestParameters.apiQuickStatusComment was null or undefined when calling updateStatusComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/quick-status-comments`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ApiQuickStatusCommentToJSON(requestParameters.apiQuickStatusComment),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiQuickStatusCommentFromJSON(jsonValue));
    }

    /**
     * Updates status comment
     */
    async updateStatusComment(requestParameters: UpdateStatusCommentRequest, initOverrides?: RequestInit): Promise<ApiQuickStatusComment> {
        const response = await this.updateStatusCommentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
